/* How long the site settings stay cached (cache-data/siteSetting.js). A good answer is kept 5 minutes. A failed read was
   kept 5 minutes too: for 5 minutes every page had no route names (header links such as the cart icon lost their
   href), no panel scripts and no storage prefix (pictures answered 404). Core 14 read the settings on every request,
   so a failure touched one request only. A failed read (`read_failed`) is now kept 5 seconds: concurrent requests still
   share one call, and the next read asks the API again. */
export const SETTINGS_TTL_SECONDS = 60 * 5;
export const FAILED_SETTINGS_TTL_SECONDS = 5;

export const settings_ttl = (value) => (value?.read_failed ? FAILED_SETTINGS_TTL_SECONDS : SETTINGS_TTL_SECONDS);
